<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'
import GmapCustomMarker from 'vue2-gmap-custom-marker'
import DatePicker from 'vue2-datepicker'
import SelectOptions from '../../liveview/RightButton/SelectOptions'
import { gmapApi } from 'vue2-google-maps'
import moment from 'moment'
moment.locale('id')

import { GET_RAW_LOCATION } from '@/services/api/fleet'
import { SUMMARY_TRIP_DRIVER, LAST_SUMMARY_TRIP_DRIVER } from '@/services/api/master/employees'
import { Helper } from '@/mixin/helper'
import { GET_DETAIL_EMPLOYEE } from '@/services/api/master/employees'

/**
 * Starter component
 */
export default {
  name: 'ModalRiwayatDriver',
  page: {
    title: 'Riwayat Perjalanan',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  mixins: [Helper],
  apollo: {
    employee: {
      query: GET_DETAIL_EMPLOYEE,
      variables() {
        return {
          filter: {
            userId: parseInt(this.$route.params.id),
          },
        }
      },
    },
    summaryTripDriver: {
      query: SUMMARY_TRIP_DRIVER,
      variables() {
        return {
          filter: {
            driverId: parseInt(this.$route.params.id),
            // startDate: "2022-07-31T17:00:00.000Z",
            // endDate: "2022-08-31T16:59:59.000Z",
            startDate: this.now(),
            endDate: this.now(),
          },
        }
      },
      result({ data, loading }) {
        if (!loading) {
          setTimeout(() => {
            this.calcRoute(data.summaryTripDriver.summaryTripDriver)
          }, 300)
        }
      },
    },
  },
  computed: {
    google: gmapApi,
  },
  components: {
    Layout,
    DatePicker,
    SelectOptions,
    'gmap-custom-marker': GmapCustomMarker,
  },
  data() {
    return {
      map: null,
      zoom: 5.56,
      center: {
        lat: -2.958881,
        lng: 109.5543666,
      },
      makeShortcuts: [
        { text: 'Hari Ini', onClick: () => [new Date(), new Date()] },
        {
          text: 'Kemarin',
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, new Date()]
          },
        },
        {
          text: '3 Hari Terakhir',
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 48)
            return [date, new Date()]
          },
        },
      ],

      employee: {
        employee: {},
      },

      summaryTripDriver: {
        summaryTripDriver: {
          summaryTrip: [],
        },
      },

      lastSummaryTripDriver: [],
      periode: [],
      allPath: [],
      showHideDetail: false,
      allHistory: true,
      popoverShow: false,
      modalDriverHistory: true,
      pastDate: null,
      futureEnd: null,
      move: {
        numDeltas: 100,
        delay: 10, //milliseconds
        i: 0,
        deltaLat: null,
        deltaLng: null,
      },

      isMonth: true,

      trafficLayer: null,
      directionsService: null,
      directionsRenderer: null,
      bounds: null,
      position: {
        start: {},
        end: {
          lat: null,
          lng: null,
        },
      },
      stopPosition: true,
      stopPositions: [],
      infoWindow: {
        status: false,
        type: 'totalHourStop',
        position: { lat: null, lng: null },
        totalHourStop: '',
        speed: 0,
        sentOn: '',
      },
      visible: true,

      myTime: 0,
      str: 0,
      stp: 0,
    }
  },
  async mounted() {
    const self = this
    this.periode[0] = this.momentYmD(new Date())
    this.periode[1] = this.momentYmD(new Date())

    const currentDate = moment()
    const pastMonth = moment(currentDate).subtract(3, 'M')
    const pastDate = moment(pastMonth).endOf('month')

    this.pastDate = pastDate
    this.futureEnd = currentDate

    await this.$refs.MapHistoryDriver.$mapPromise.then((map) => {
      self.map = map
      var directionsService = new this.google.maps.DirectionsService()
      var directionsRenderer = new this.google.maps.DirectionsRenderer({
        suppressMarkers: false,
      })
      const trafficLayer = new this.google.maps.TrafficLayer()
      this.trafficLayer = trafficLayer
      this.directionsService = directionsService
      this.directionsRenderer = directionsRenderer
    })
  },
  methods: {
    disabledRange: function (date) {
      return date <= this.pastDate || date >= this.futureEnd
    },

    pickDate(date) {
      this.isMonth = !this.isMonth

      if (this.isMonth) {
        const currentDate = moment()
        const pastMonth = moment(currentDate).subtract(3, 'M')
        const pastDate = moment(pastMonth).endOf('month')

        this.pastDate = pastDate
        this.futureEnd = currentDate
      } else {
        this.pastDate = new Date(date.getTime() - 24 * 3 * 3600 * 1000)
        if (new Date(date.getTime() + 24 * 0 * 3600 * 1000) == new Date()) {
          this.futureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
        } else {
          this.futureEnd = new Date(date.getTime() + 24 * 3 * 3600 * 1000)
        }
      }
    },

    async loadData() {
      await this.$apollo.queries.summaryTripDriver.refetch({
        filter: {
          startDate: this.momentToISOString(`${this.periode[0]} 00:00:00`),
          endDate: this.momentToISOString(`${this.periode[1]} 23:59:59`),
          driverId: parseInt(this.$route.params.id),
        },
      })

      this.calcRoute(this.summaryTripDriver.summaryTripDriver.summaryTrips)
    },

    OpenInfo(lat, lng, totalHourStop) {
      this.CloseInfo()
      setTimeout(() => {
        this.infoWindow.status = true
        this.infoWindow.type = 'totalHourStop'
        ;(this.infoWindow.position = {
          lat: lat,
          lng: lng,
        }),
          (this.infoWindow.totalHourStop = totalHourStop)
      }, 100)
    },

    CloseInfo() {
      this.infoWindow.status = false
    },

    showLineDetail(event, fleetPlanCoordinates) {
      this.infoWindow.status = false
      setTimeout(() => {
        this.infoWindow.status = true
        this.infoWindow.type = 'speed'
        this.infoWindow.position = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        }
        this.infoWindow.speed = fleetPlanCoordinates.speed
        this.infoWindow.sentOn = fleetPlanCoordinates.sentOn
      }, 100)
    },

    calcRoute(data) {
      this.resetPolyline()
      setTimeout(() => {
        if (data.summaryTrips.length == 0) {
          this.setMarker('start', { lat: null, lng: null }, 0)
          this.setMarker('end', { lat: null, lng: null }, 0)
          return
        }
        var self = this
        var bounds = new this.google.maps.LatLngBounds()

        bounds.extend(
          new self.google.maps.LatLng(data.summaryTrips[0].startLat, data.summaryTrips[0].startLong)
        )

        bounds.extend(
          new self.google.maps.LatLng(
            data.summaryTrips[data.summaryTrips.length - 1].stopLat,
            data.summaryTrips[data.summaryTrips.length - 1].stopLong
          )
        )

        const lastIndex = data.summaryTrips.length - 1
        data.summaryTrips.forEach(async (element, index) => {
          bounds.extend(new self.google.maps.LatLng(element.startLat, element.startLong))

          bounds.extend(new self.google.maps.LatLng(element.stopLat, element.stopLong))
          let filter = {
            filter: {
              vehicleId: element.vehicleId,
              startDate: element.startTime,
              endDate: element.stopTime,
            },
          }

          this.getLine(filter, lastIndex, index, element.totalHourStop, false)
        })
        this.map.fitBounds(bounds)
      }, 100)
    },

    createAllPolyline() {
      this.resetPolyline()
      this.stopPosition = true
      this.infoWindow.status = false
      var allFleetPlanCoordinates = []
      setTimeout(() => {
        this.summaryTripDriver.summaryTripDriver.summaryTrips
          .slice()
          .reverse()
          .forEach((element) => {
            const fleetPlanCoordinates = element.details
            allFleetPlanCoordinates = [...allFleetPlanCoordinates, ...element.details]
            for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
              var polylinePlanCoordinates = []

              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i]['latitude'],
                  fleetPlanCoordinates[i]['longitude']
                )
              )
              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i + 1]['latitude'],
                  fleetPlanCoordinates[i + 1]['longitude']
                )
              )
              this.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)
            }
          })
        this.moving(allFleetPlanCoordinates)
      }, 200)
    },

    createPolyline(index, totalHourStop) {
      this.resetPolyline()
      this.stopPosition = false
      this.infoWindow.status = false
      const fleetPlanCoordinates =
        this.summaryTripDriver.summaryTripDriver.summaryTrips[index].details

      setTimeout(() => {
        for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
          if (i == 0) {
            this.setMarker(
              'start',
              {
                lat: fleetPlanCoordinates[i].latitude,
                lng: fleetPlanCoordinates[i].longitude,
              },
              0,
              totalHourStop
            )
          }
          var polylinePlanCoordinates = []

          polylinePlanCoordinates.push(
            new this.google.maps.LatLng(
              fleetPlanCoordinates[i].latitude,
              fleetPlanCoordinates[i].longitude
            )
          )
          polylinePlanCoordinates.push(
            new this.google.maps.LatLng(
              fleetPlanCoordinates[i + 1].latitude,
              fleetPlanCoordinates[i + 1].longitude
            )
          )

          this.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)
        }

        this.moving(fleetPlanCoordinates)
      }, 200)
    },

    getLine(filter, lastIndex, index, totalHourStop, play) {
      var self = this
      self.stopPositions.splice(0, self.stopPositions.length)

      this.$apollo
        .query({
          query: GET_RAW_LOCATION,
          variables: filter,
        })
        .then((response) => {
          if (response.data.rawLocations.isSuccessful) {
            const fleetPlanCoordinates = response.data.rawLocations.rawLocations
            var bounds = new this.google.maps.LatLngBounds()

            if (index == 0) {
              this.setMarker(
                'end',
                {
                  lat: fleetPlanCoordinates[fleetPlanCoordinates.length - 1].latitude,
                  lng: fleetPlanCoordinates[fleetPlanCoordinates.length - 1].longitude,
                },
                parseInt(fleetPlanCoordinates[fleetPlanCoordinates.length - 1].direction)
              )
            }

            for (var i = 0; i < fleetPlanCoordinates.length - 1; i++) {
              var polylinePlanCoordinates = []

              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i].latitude,
                  fleetPlanCoordinates[i].longitude
                )
              )
              polylinePlanCoordinates.push(
                new this.google.maps.LatLng(
                  fleetPlanCoordinates[i + 1].latitude,
                  fleetPlanCoordinates[i + 1].longitude
                )
              )

              self.crateLine(fleetPlanCoordinates[i], polylinePlanCoordinates)

              if (i == 0) {
                self.stopPositions.push({
                  lat: fleetPlanCoordinates[i].latitude,
                  lng: fleetPlanCoordinates[i].longitude,
                  totalHourStop: totalHourStop,
                })
              }

              if (lastIndex == 0 && index == 0) {
                bounds.extend(
                  new self.google.maps.LatLng(
                    fleetPlanCoordinates[i].latitude,
                    fleetPlanCoordinates[i].longitude
                  )
                )
              }
            }

            if (lastIndex == index && lastIndex != 0) {
              this.setMarker(
                'start',
                {
                  lat: fleetPlanCoordinates[0].latitude,
                  lng: fleetPlanCoordinates[0].longitude,
                },
                0,
                totalHourStop
              )
            } else if (lastIndex == 0 && index == 0) {
              this.setMarker(
                'start',
                {
                  lat: fleetPlanCoordinates[0].latitude,
                  lng: fleetPlanCoordinates[0].longitude,
                },
                0,
                totalHourStop
              )
              this.setMarker(
                'end',
                {
                  lat: fleetPlanCoordinates[i].latitude,
                  lng: fleetPlanCoordinates[i].longitude,
                },
                parseInt(fleetPlanCoordinates[i].direction)
              )
              this.map.fitBounds(bounds)

              if (play) {
                // setTimeout(() => {
                self.stop(self.str, self.stp)
                var interval = 500
                fleetPlanCoordinates.forEach(function (row, i) {
                  this.myTime = setTimeout(function () {
                    self.transition(
                      [row.latitude, row.longitude],
                      [fleetPlanCoordinates[i + 1].latitude, fleetPlanCoordinates[i + 1].longitude],
                      fleetPlanCoordinates[i + 1].direction
                    )
                  }, i * interval)

                  if (i == 0) {
                    this.str = this.myTime
                  } else if (i == fleetPlanCoordinates.length - 1) {
                    this.stp = this.myTime
                  }
                })
                // }, 1000);
              }
            }

            this.summaryTripDriver.summaryTripDriver.summaryTrips[index] = {
              ...this.summaryTripDriver.summaryTripDriver.summaryTrips[index],
              details: fleetPlanCoordinates,
            }
          }
        })
        .catch((e) => console.log(e))
    },

    async createPolylineMoving(totalHourStop, play) {
      this.resetPolyline()
      const filter = {
        filter: {
          startDate: this.lastSummaryTripDriver.summaryTrips.startTime,
          endDate: this.lastSummaryTripDriver.summaryTrips.stopTime,
          vehicleId: this.lastSummaryTripDriver.summaryTrips.vehicleId,
        },
      }

      this.getLine(filter, 0, 0, totalHourStop, play)
    },

    async crateLine(fleetPlanCoordinates, polylinePlanCoordinates) {
      // create a polyline
      var self = this
      var path = new this.google.maps.Polyline({
        path: polylinePlanCoordinates,
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 5,
      })

      path.addListener('click', function (e) {
        self.showLineDetail(e, fleetPlanCoordinates)
      })

      this.allPath.push(path)

      // set the color of the segment based on the lowest index point
      if (fleetPlanCoordinates.speed >= 0 && fleetPlanCoordinates.speed <= 20) {
        path.setOptions({
          strokeColor: '#f41d00',
        })
      } else if (fleetPlanCoordinates.speed > 20 && fleetPlanCoordinates.speed <= 40) {
        path.setOptions({
          strokeColor: '#f64a33',
        })
      } else if (fleetPlanCoordinates.speed > 40 && fleetPlanCoordinates.speed <= 60) {
        path.setOptions({
          strokeColor: '#ffa133',
        })
      } else if (fleetPlanCoordinates.speed > 60 && fleetPlanCoordinates.speed <= 80) {
        path.setOptions({
          strokeColor: '#71b099',
        })
      } else if (fleetPlanCoordinates.speed > 80) {
        path.setOptions({
          strokeColor: '#137c55',
        })
      }

      path.setMap(this.map)
    },

    resetPolyline() {
      this.allPath.forEach((element) => {
        element.setMap(null)
      })

      this.allPath.splice(0, this.allPath.length)
    },

    setMarker(type, coordinate, direction, totalHourStop) {
      this.position[type] = {
        lat: coordinate.lat,
        lng: coordinate.lng,
        direction: parseInt(direction),
        totalHourStop: totalHourStop,
      }
    },

    moving(fleetPlanCoordinates) {
      const self = this
      let interval = 100

      this.stop(this.str, this.stp)
      // setTimeout(() => {
      for (let i = 0; i < fleetPlanCoordinates.length; i++) {
        this.myTime = setTimeout(function () {
          self.transition(
            [fleetPlanCoordinates[i].latitude, fleetPlanCoordinates[i].longitude],
            [fleetPlanCoordinates[i + 1].latitude, fleetPlanCoordinates[i + 1].longitude],
            fleetPlanCoordinates[i + 1].direction
          )
        }, i * interval)

        if (i == 0) {
          this.str = this.myTime
        } else if (i == fleetPlanCoordinates.length - 1) {
          this.stp = this.myTime
        }
      }
      // }, 1000);
    },

    stop(str1, stp1) {
      for (let i = str1; i < stp1; i++) {
        clearTimeout(i)
      }
    },

    transition(start, stop, direction) {
      this.move.i = 0
      this.move.deltaLat = (stop[0] - start[0]) / this.move.numDeltas
      this.move.deltaLng = (stop[1] - start[1]) / this.move.numDeltas
      this.moveMarker(stop, direction)
    },

    moveMarker(stop, direction) {
      stop[0] += this.move.deltaLat
      stop[1] += this.move.deltaLng

      this.setMarker(
        'end',
        {
          lat: stop[0],
          lng: stop[1],
        },
        parseInt(direction)
      )
      if (this.move.i != this.move.numDeltas) {
        this.move.i++
        setTimeout(this.move.moveMarker, this.move.delay)
      }
    },

    onClose() {
      this.popoverShow = false
    },

    toggleSideBar() {
      this.modalDriverHistory = !this.modalDriverHistory
    },

    getMoving() {
      // if (this.summaryTripDriver.summaryTripDriver.motionStatus !== "M") {
      // 	return;
      // }

      // var self = this;
      this.$apollo
        .query({
          query: LAST_SUMMARY_TRIP_DRIVER,
          variables: {
            filter: {
              driverId: parseInt(this.$route.params.id),
            },
          },
        })
        .then((response) => {
          if (response.data.lastSummaryTripDriver.isSuccessful) {
            this.lastSummaryTripDriver = response.data.lastSummaryTripDriver.lastSummaryTripDriver
            this.allHistory = !this.allHistory
          }
        })
        .catch((e) => console.log(e))
    },
  },
}
</script>

<template>
  <Layout>
    <div
      :class="{
        'card mc-liveview clearfix': modalDriverHistory === true,
        'card mc-liveview clearfix close-sidebar': modalDriverHistory === false,
      }"
    >
      <div class="mc-liveview__map close-history">
        <div class="mc-liveview-ico">
          <SelectOptions />
          <span>
            <span class="mc-liveview-ico__legend">
              <b-avatar
                :title="$t('liveView.option.title')"
                id="legend"
                button
                :variant="$store.state.config.theme_appearance"
                class="mr-2"
              >
                <i class="icon-outline_info"></i>
              </b-avatar>

              <b-popover
                target="legend"
                triggers="click"
                placement="righttop"
                container="my-container"
                ref="popover"
                :variant="$store.state.config.theme_appearance"
                :show.sync="popoverShow"
              >
                <template #title>
                  {{ $t('notes') }}
                  <span class="mc-popover-close" @click="onClose" aria-hidden="true">&times;</span>
                </template>

                <div class="mc-popover-content mc-popover-content--legend">
                  <ul>
                    <li>
                      <p>{{ $t('vehicle.status') }}</p>
                      <div>
                        <label
                          ><img src="@/assets/images/caricon/car-green.svg" alt /><span>{{
                            $t('started')
                          }}</span></label
                        >
                        <label
                          ><img src="@/assets/images/caricon/car-yellow.svg" alt /><span>{{
                            $t('still')
                          }}</span></label
                        >
                        <label
                          ><img src="@/assets/images/caricon/car-red.svg" alt /><span>{{
                            $t('parking')
                          }}</span></label
                        >
                        <label
                          ><img src="@/assets/images/caricon/car-grey.svg" alt /><span>{{
                            $t('offline')
                          }}</span></label
                        >
                      </div>
                    </li>
                    <li>
                      <p>{{ $t('vehicleColor') }}</p>
                      <div>
                        <label
                          ><u></u> <span>&#62; 80 Km/{{ $t('hour') }}</span></label
                        >
                        <label
                          ><u></u> <span>61 - 80 Km/{{ $t('hour') }}</span></label
                        >
                        <label
                          ><u></u> <span>41 - 60 Km/{{ $t('hour') }}</span></label
                        >
                        <label
                          ><u></u> <span>21 - 40 Km/{{ $t('hour') }}</span></label
                        >
                        <label
                          ><u></u> <span>&#60; 20 Km/{{ $t('hour') }}</span></label
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </b-popover>
            </span>
          </span>
        </div>
        <div class="mc-map-wrapper mc-map-wrapper--employee">
          <GmapMap id="map" ref="MapHistoryDriver" :center="center" :zoom="zoom" class="mc-map">
            <gmap-custom-marker
              v-for="(row, index) in stopPositions"
              :key="index"
              :marker="{
                lat: parseFloat(row.lat),
                lng: parseFloat(row.lng),
              }"
              :offsetY="40"
            >
              <div v-if="stopPosition" class="text-center">
                <img
                  role="button"
                  @click="OpenInfo(parseFloat(row.lat), parseFloat(row.lng), row.totalHourStop)"
                  src="@/assets/images/caricon/stop-icon.svg"
                />
              </div>
            </gmap-custom-marker>

            <GmapInfoWindow
              :position="infoWindow.position"
              :opened="infoWindow.status"
              @closeclick="CloseInfo"
            >
              <div
                class="mc-modal-fleet mc-modal-fleet--history mc-modal-fleet--history-stop"
                v-if="infoWindow.type === 'totalHourStop'"
              >
                <div class="mc-modal-fleet__item-status clearfix">
                  <p><i class="mc-fa icon-outline_timer"></i> {{ $t('liveView.modal.stopDuration') }}</p>
                  <span>{{ infoWindow.totalHourStop }}</span>
                </div>
              </div>
              <div
                class="mc-modal-fleet mc-modal-fleet--history mc-modal-fleet--history-speed"
                v-else-if="infoWindow.type === 'speed'"
              >
                <div class="mc-modal-fleet__item-status clearfix">
                  <p>
                    <i class="mc-fa icon-outline_eye"></i>
                    {{ momentDMY_HI(infoWindow.sentOn) }}
                  </p>
                  <p><i class="mc-fa icon-outline_odometer"></i> {{ $t('speed') }}</p>
                  <span>{{ infoWindow.speed }} Km/{{ $t('hour') }}</span>
                  <p><i class="mc-fa"></i></p>
                </div>
              </div>
            </GmapInfoWindow>

            <span v-if="!stopPosition">
              <gmap-custom-marker
                v-for="(row, index) in stopPositions"
                :key="index"
                :marker="{
                  lat: parseFloat(position.start.lat),
                  lng: parseFloat(position.start.lng),
                }"
                :offsetY="40"
              >
                <div class="text-center">
                  <img
                    role="button"
                    @click="
                      OpenInfo(
                        parseFloat(position.start.lat),
                        parseFloat(position.start.lng),
                        position.start.totalHourStop
                      )
                    "
                    src="@/assets/images/caricon/stop-icon.svg"
                  />
                </div>
              </gmap-custom-marker>
            </span>

            <gmap-custom-marker
              v-if="position.end.lat && position.end.lng"
              :marker="{
                lat: parseFloat(position.end.lat),
                lng: parseFloat(position.end.lng),
              }"
              :offsetY="25"
            >
              <div class="text-center">
                <div
                  v-if="$store.state.fleets.markerPlate === true"
                  :class="`${
                    $store.state.fleets.markerLabelLayout === true
                      ? 'bg-white bottom-icon-shape'
                      : 'bg-transparant'
                  }`"
                  class="rounded"
                >
                  <h6 class="p-1">
                    <strong>{{ employee.employee.fullname }}</strong>
                  </h6>
                </div>
                <img
                  src="@/assets/images/caricon/car-dark.svg"
                  :style="`transform: rotate(${parseInt(position.end.direction)}deg);`"
                  alt="mceasy-lifeview-car-icon"
                />
              </div>
            </gmap-custom-marker>
          </GmapMap>

          <span class="mc-sidebar-toggle" @click="toggleSideBar">
            <i class="mc-fa fas fa-angle-left"></i>
          </span>

          <b-modal
            id="modal-history"
            scrollable
            hide-footer
            size="md"
            class="mc-history-modal"
            no-close-on-backdrop
            hide-backdrop
            v-model="modalDriverHistory"
          >
            <section v-if="allHistory">
              <!-- header -->
              <div slot="modal-header">
                <div class="card-title">
                  <span>{{ $t('master.form.driver.fleetHis.text') }}</span>
                  <h4 class="mt-1">{{ employee.employee.fullname }}</h4>
                  <b-button
                    class="mc-history-fleet__back"
                    variant="outline-primary"
                    @click="$router.push({ name: 'Master Employee Detail' })"
                  >
                    <i class="fas fa-long-arrow-alt-left"></i>
                    {{ $t('global.back') }}
                  </b-button>
                </div>
              </div>
              <!-- body -->
              <div class="modal-body">
                <div class="text-center" v-if="$store.state.fleets.loadingHistory">
                  <div class="mc-loading">
                    <p></p>
                    <p></p>
                    <p></p>
                  </div>
                </div>
                <b-row v-else class="mc-history-modal__list">
                  <b-col md="8" class="mb-3">
                    <label>{{ $t('Periodic') }}</label>
                    <date-picker
                      v-model="periode"
                      placeholder="Pilih Tanggal"
                      format="DD MMM YYYY"
                      value-type="YYYY-MM-DD"
                      :shortcuts="makeShortcuts"
                      range-separator=" - "
                      range
                      :disabled-date="disabledRange"
                      @pick="pickDate"
                    ></date-picker>
                  </b-col>
                  <b-col md="4">
                    <b-button block class="mc-btn--block" variant="primary" @click="loadData">{{
                      $t('apply')
                    }}</b-button>
                  </b-col>
                  <b-col md="8">
                    <div class="form-check-right form-switch">
                      <input
                        class="form-check-input ms-2"
                        type="checkbox"
                        id="moreinfo-history"
                        v-on:click="showHideDetail = !showHideDetail"
                      />
                      <span class="" for="moreinfo-history"> {{ $t('master.form.driver.additional.text') }} </span>
                    </div>
                  </b-col>
                  <b-col mc="4" class="text-end">
                    <a @click="createAllPolyline" class="text-primary"
                      ><i class="icon-outline_play-circle"></i> {{ $t('all') }}</a
                    >
                  </b-col>
                  <b-col md="12" class="mt-3">
                    <div class="mc-history-fleet">
                      <b-list-group class="mc-history-fleet__list">
                        <b-list-group class="mc-history-fleet__list">
                          <b-list-group-item
                            v-for="(row, index) in summaryTripDriver.summaryTripDriver.summaryTrips"
                            :key="index"
                          >
                            <div class="d-flex justify-content-between">
                              <div>
                                <span>{{ $t('startTime') }}</span>
                                <p>{{ momentDMY_HI(row.startTime) }}</p>
                              </div>
                              <div>
                                <span>{{ $t('endTime') }}</span>
                                <p>{{ momentDMY_HI(row.stopTime) }}</p>
                              </div>
                              <div>
                                <a
                                  @click="createPolyline(index, row.totalHourStop)"
                                  class="text-primary"
                                  ><i class="icon-outline_play-circle"></i
                                ></a>
                              </div>
                            </div>
                            <dl class="clearfix" v-if="showHideDetail">
                              <dt>{{ $t('liveView.modal.tripTotal') }}</dt>
                              <dd>{{ row.totalHourStart }}</dd>
                              <dt>{{ $t('liveView.modal.tripDistance') }}</dt>
                              <dd>{{ row.tripMileage }}</dd>
                              <dt>{{ $t('liveView.modal.stopDuration') }}</dt>
                              <dd>{{ row.totalHourStop }}</dd>
                              <dt>{{ $t('vehicle') }}</dt>
                              <dd>{{ row.vehicle.licensePlate }}</dd>
                            </dl>
                          </b-list-group-item>
                        </b-list-group>
                      </b-list-group>
                    </div>

                    <b-list-group class="mc-history-fleet__list-total my-2">
                      <b-list-group-item>
                        <div>
                          <p>Total</p>
                          <dl class="clearfix">
                            <dt>{{ $t('liveView.modal.tripTotal') }}</dt>
                            <dd>
                              {{ summaryTripDriver.summaryTripDriver.totalHourStart }}
                            </dd>
                            <dt>{{ $t('liveView.modal.tripDistance') }}</dt>
                            <dd>
                              {{ summaryTripDriver.summaryTripDriver.totalTrip }}
                            </dd>
                            <dt>{{ $t('liveView.modal.stopDuration') }}</dt>
                            <dd>
                              {{ summaryTripDriver.summaryTripDriver.totalHourStop }}
                            </dd>
                          </dl>
                        </div>
                      </b-list-group-item>
                    </b-list-group>
                  </b-col>
                </b-row>
              </div>
            </section>
            <section v-else class="mc-history-fleet__new">
              <!-- header -->
              <div slot="modal-header">
                <div class="card-title">
                  <h4>{{ $t('newTravelHistory') }}</h4>
                  <b-button
                    class="mc-history-fleet__back"
                    variant="outline-primary"
                    @click="allHistory = !allHistory"
                  >
                    <i class="fas fa-long-arrow-alt-left"></i>
                    {{ $t('global.back') }}
                  </b-button>
                </div>
              </div>

              <!-- Body -->
              <div class="modal-body">
                <div class="mc-history-fleet__new-number">
                  <div class="d-flex justify-content-between">
                    <div>
                      <p>{{ $t('vehicle') }}</p>
                      <strong>{{ lastSummaryTripDriver.summaryTrips.vehicle.licensePlate }}</strong>
                    </div>
                    <div>
                      <p>{{ $t('driver') }}</p>
                      <strong>{{ employee.employee.fullname }}</strong>
                    </div>
                  </div>
                </div>
                <div class="mc-history-modal__list">
                  <div class="mc-history-fleet">
                    <b-list-group class="mc-history-fleet__list">
                      <b-list-group-item>
                        <div class="d-flex justify-content-between">
                          <div>
                            <span>{{ $t('startTime') }}</span>
                            <p>
                              {{ momentDMY_HI(lastSummaryTripDriver.summaryTrips.startTime) }}
                            </p>
                          </div>
                          <div>
                            <span>{{ $t('liveView.modal.stopDuration') }}</span>
                            <p>
                              {{ momentDMY_HI(lastSummaryTripDriver.summaryTrips.stopTime) }}
                            </p>
                          </div>
                          <div>
                            <a
                              @click="
                                createPolylineMoving(lastSummaryTripDriver.totalHourStop, true)
                              "
                              class="text-primary"
                              ><i class="icon-outline_play-circle"></i
                            ></a>
                          </div>
                        </div>
                        <dl class="clearfix">
                          <dt>{{ $t('liveView.modal.tripTotal') }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalHourStart }}</dd>
                          <dt>{{ $t('liveView.modal.tripDistance') }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalTrip }}</dd>
                          <dt>{{ $t('liveView.modal.stopDuration') }}</dt>
                          <dd>{{ lastSummaryTripDriver.totalHourStop }}</dd>
                        </dl>
                      </b-list-group-item>
                    </b-list-group>
                  </div>
                </div>
              </div>
            </section>
          </b-modal>
        </div>
      </div>
    </div>
  </Layout>
</template>
